import { cloneObject } from './cloneObject';

// Deleta as chaves null, undefined ou '' dos objetos
function clearObject(obj) {
    const newObj = cloneObject(obj);

    if (Array.isArray(newObj)) newObj.forEach((item) => clearObject(item));

    Object.keys(newObj).forEach((k) => {
        if (newObj[k] && Array.isArray(newObj[k])) newObj[k].forEach((j) => clearObject(j));
        if (newObj[k] && typeof newObj[k] === 'object') clearObject(newObj[k]);
        return !newObj[k] && delete newObj[k];
    });

    return newObj;
}

export { clearObject };
